__turbopack_context__.v({
  "close-search-button": "oLDOFa_close-search-button",
  "container-pwa": "oLDOFa_container-pwa",
  "currency-menu": "oLDOFa_currency-menu",
  "isHome": "oLDOFa_isHome",
  "language-selector": "oLDOFa_language-selector",
  "link": "oLDOFa_link",
  "logoContainerDesk": "oLDOFa_logoContainerDesk",
  "logoContainerDesktop": "oLDOFa_logoContainerDesktop",
  "logoContainerMobile": "oLDOFa_logoContainerMobile",
  "megamenu-cms": "oLDOFa_megamenu-cms",
  "mobile-search-icon": "oLDOFa_mobile-search-icon",
  "nav-container": "oLDOFa_nav-container",
  "nav-container-bottom": "oLDOFa_nav-container-bottom",
  "nav-container-inner": "oLDOFa_nav-container-inner",
  "nav-container-right": "oLDOFa_nav-container-right",
  "nav-pwa-inner": "oLDOFa_nav-pwa-inner",
  "nav-section": "oLDOFa_nav-section",
  "navHidden": "oLDOFa_navHidden",
  "navSticky": "oLDOFa_navSticky",
  "overHero": "oLDOFa_overHero",
  "root": "oLDOFa_root",
  "scrolledUp": "oLDOFa_scrolledUp",
  "search-display": "oLDOFa_search-display",
  "search-focused": "oLDOFa_search-focused",
  "search-focused-bottom": "oLDOFa_search-focused-bottom",
  "shadow-magical": "oLDOFa_shadow-magical",
  "toggle-search": "oLDOFa_toggle-search",
});
